import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ButtonGroup from 'reactstrap/lib/ButtonGroup';
import { MapStopDto } from '../../../../../../api/UnitMap';
import Button from '../../../../../common/form/Button';
import CheckboxLabeled from '../../../../../common/form/CheckboxLabeled';
import FormInput from '../../../../../common/form/Input';
import FormSelectLabeled from '../../../../../common/form/SelectLabeled';
import { Floor } from '../../../../../common/UnitMap/UnitMapTypes';

interface Props {
    isFirst: boolean;
    isLast: boolean;
    stop: MapStopDto;
    isEditing: boolean;
    onStopChanged: (newConfig?: MapStopDto) => void;
    onEditStop: () => void;
    onReorder: (moveUp: boolean) => void;
    floorList?: Floor[];
}

const StopConfiguration = (props: Props) => (
    <>
        {props.floorList && (
            <Container className="stop-configuration">
                <Row className="justify-content-center">
                    <Col xs={10}>
                        <FormInput
                            labelProps={{
                                labelText: 'Description',
                                invalidText: 'Please enter a description'
                            }}
                            inputProps={{
                                id: 'description',
                                name: 'description',
                                value: props.stop.description,
                                type: 'string',
                                required: false,
                                maxLength: 50
                            }}
                            onChange={(_name, value) => {
                                props.onStopChanged({
                                    ...props.stop,
                                    description: value.toString()
                                });
                            }}
                        />
                        <FormInput
                            labelProps={{
                                labelText: 'Directions',
                                invalidText: 'Please enter directions'
                            }}
                            inputProps={{
                                id: 'directions',
                                name: 'directions',
                                value: props.stop.directions,
                                type: 'textarea',
                                required: false,
                                maxLength: 500
                            }}
                            onChange={(_name, value) => {
                                props.onStopChanged({
                                    ...props.stop,
                                    directions: value.toString()
                                });
                            }}
                        />
                    </Col>

                    <Col xs={2} className="justify-content-center">
                        <ButtonGroup className="btn-group-vertical">
                            <Button
                                text="Up"
                                onClick={() => {
                                    props.onReorder(true);
                                }}
                                disabled={props.isFirst}
                            />
                            <Button
                                text="Down"
                                onClick={() => {
                                    props.onReorder(false);
                                }}
                                disabled={props.isLast}
                            />
                            <Button
                                text="Delete"
                                onClick={() => {
                                    props.onStopChanged();
                                }}
                                disabled={props.isFirst || props.isLast}
                            />
                        </ButtonGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={3}>
                        <FormInput
                            labelProps={{
                                labelText: 'X',
                                invalidText: ''
                            }}
                            inputProps={{
                                id: 'x',
                                name: 'x',
                                value: props.stop.x,
                                type: 'number',
                                required: true,
                                max: '10000',
                                min: '-10000'
                            }}
                            onChange={(_name, value) => {
                                props.onStopChanged({
                                    ...props.stop,
                                    x: value as number
                                });
                            }}
                        />
                    </Col>
                    <Col xs={3}>
                        <FormInput
                            labelProps={{
                                labelText: 'Y',
                                invalidText: ''
                            }}
                            inputProps={{
                                id: 'y',
                                name: 'y',
                                value: props.stop.y,
                                type: 'number',
                                required: true,
                                max: '10000',
                                min: '-10000'
                            }}
                            onChange={(_name, value) => {
                                props.onStopChanged({
                                    ...props.stop,
                                    y: value as number
                                });
                            }}
                        />
                    </Col>
                    <Col xs={4}>
                        <FormSelectLabeled
                            labelProps={{
                                labelText: 'Select Floor',
                                invalidText: undefined
                            }}
                            selectProps={{
                                id: 'floor',
                                name: 'floor',
                                required: true,
                                value: props.stop.floor,
                                disabled: false,
                                clearable: false,
                                searchable: true
                            }}
                            selectOptions={props.floorList.map(f => {
                                return {
                                    value: f.value,
                                    label: f.name
                                };
                            })}
                            onChange={(_name, value) => {
                                return (
                                    value &&
                                    props.onStopChanged({ ...props.stop, floor: value.toString() })
                                );
                            }}
                        />
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <CheckboxLabeled
                        labelProps={{ labelText: 'Use alternate color (for Amenities)' }}
                        inputProps={{
                            id: 'isAmenity',
                            name: 'isAmenity',
                            checked: props.stop.isAmenity
                        }}
                        onChange={(_name, value) => {
                            props.onStopChanged({
                                ...props.stop,
                                isAmenity: value
                            });
                        }}
                    />
                </Row>
                <Row>
                    <Col xs={2}>
                        <Button
                            text="Place on map"
                            onClick={() => {
                                props.onEditStop();
                            }}
                        />
                    </Col>
                </Row>
            </Container>
        )}
    </>
);

export default StopConfiguration;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/unitMapControls/StopConfiguration.tsx